import React from 'react';
import AddEditPlanForm from 'ui-component/addEditPlanForm';
import AddEditRoleForm from 'ui-component/AddEditRoleForm';

function EditPlan() {
  return (
    <div>
      <AddEditPlanForm title="Edit Plan" />
    </div>
  );
}

export default EditPlan;
